export const koKR_avatorDropMenu = {
  'header.avator.account': '계정',
  'header.avator.logout': '로그아웃',
  'global.theme.switchTheme': '테마 변경',
  'global.theme.switchingTheme': '테마 변경중...',
  'global.theme.switchThemeDone': '테마 변경 성공!',
  'global.theme.switchThemeFail': '테마 변경 실패',
};
